<template>
    <div class="payinfo">
        <template v-if="info.isthirdinfo">
            <template v-if="info.seal_status * 1 > 0">
                 <div class="match-pay disabled">
                    <i class="icon i_shang"></i>
                    <span class="need-money">{{info.fee}}嗨币{{newBuybtn}}</span>
                    <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                        <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                    </template>
                    <template v-else-if="info.type == '27'">
                        <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                    </template>
                </div>
            </template>
            <template v-else>
                 <div class="match-pay">
                    <i class="icon i_shang"></i>
                    <span class="need-money">{{info.fee}}嗨币{{new_buybtn}}</span>
                    <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                        <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                    </template>
                    <template v-else-if="info.type == '27'">
                        <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                    </template>
                </div>
            </template>
        </template>
        <template v-else>
            <template v-if="info.seal_status * 1 > 0">
                <div class="match-pay disabled">
                    <i class="icon i_shang"></i>
                    <span class="need-money">{{info.fee}}嗨币{{new_buybtn}}</span>
                    <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                        <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                    </template>
                    <template v-else-if="info.type == '27'">
                        <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                    </template>
                </div>
            </template>
            <template v-else>
                <template v-if="info.type == '27'">
                    <div class="pay-way">
                        <div :class="{'match-pay-full':true, 'only-one': !bought, 'active':fullFlag, 'pay-height':true}">
                            <span class="need-money">{{info.fee}}嗨币{{new_buybtn}}</span>
                            <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                                <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                            </template>
                            <template v-else-if="info.type == '27'">
                                <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                            </template>
                        </div>
                        <div :class="{'match-pay-dis':true, 'none': !bought, 'active':!fullFlag, 'pay-height':true}">
                            <img class='pay-dis' src="http://s.jihaimall.com/h5/image/discountcard/payDis.png" />
                            <span class="need-money">{{formatNums(info.fee * dis_discount ,2 )}}嗨币{{new_buybtn}}</span>
                            <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                                <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                            </template>
                            <template v-else-if="info.type == '27'">
                                <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="pay-way">
                        <div :class="{'match-pay-full':true, 'only-one': !bought && info.need_back == 1,'one-nohitnoback':!bought && info.need_back == 0, 'active':fullFlag && info.need_back == 1, 'noback-active':fullFlag && info.need_back == 0, 'pay-height':(info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12) && info.need_back == 1,'noback':info.need_back==0}">
                            <span class="need-money">{{info.fee}}嗨币{{new_buybtn}}</span>
                            <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                                <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                            </template>
                            <template v-else-if="info.type == '27'">
                                <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                            </template>
                        </div>
                        <div :class="{'match-pay-dis':true, 'none': !bought, 'active':!fullFlag && info.need_back == 1, 'noback-active':!fullFlag && info.need_back == 0, 'pay-height':(info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12) && info.need_back == 1,'noback':info.need_back==0}">
                            <img class='pay-dis' src="http://s.jihaimall.com/h5/image/discountcard/payDis.png" />
                            <span class="need-money">{{formatNums(info.fee * dis_discount ,2 )}}嗨币{{new_buybtn}}</span>
                            <template v-if="info.type == 2 || info.type == 9 || info.type == 11 || info.type == 12">
                                <span v-if="info.need_back == 1" class="need-back">({{newsTxtAdjust ? "不红返还" : "不中返还"}})</span>
                            </template>
                            <template v-else-if="info.type == '27'">
                                <span class="need-back">({{newsTxtAdjust ? "不红不返" : "不中不返"}})</span>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import { textAdjustment, newsAdjustment, formatNum } from "../../utils/base"
export default {
    name: "payinfo",
    props: ['info'],
    data () {
        return {
            newBuybtn: '阅读全文',
            newTxt384: 0,
            newsTxtAdjust: 0,
            bought: false, // 打折扣
            fullFlag: false, // 优惠卷？？？
            dis_discount: 0.6
        }
    },
    mounted () {
        this.initFun()
    },
    methods: {
        formatNums (data) {
            return formatNum(data)
        },
        initFun () {
            if (textAdjustment()) {
                this.newTxt384 = 1
                this.newBuybtn = '解锁预测'
            }
            if (newsAdjustment()) {
                this.newsTxtAdjust = 1
            }
        }
    }
}
</script>
